<template>
  <v-text-field ref="input"
                v-model="formatted"
                v-mask="'##/##/####'"
                :label="label"
                :required="required"
                :disabled="disabled"
                :hint="hint"
                :persistent-hint="persistentHint"
                :solo="solo"
                :class="[textInputClass, large ? 'reg-large-inline-calendar' : '']"
                :hide-details="hideDetails"
                :single-line="singleLine"
                :prepend-icon="prependIcon"
                :placeholder="placeholder"
                :rules="rules"
                :filled="box"
                type="tel"
                @blur="parseInput(formatted)">
    <template #append>
      <v-menu v-model="menu"
              :disabled="disabled"
              transition="scale-transition"
              offset-y
              bottom
              left
              min-width="0">
        <template #activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">
            event
          </v-icon>
        </template>
        <v-date-picker v-model="localDate"
                       :picker-date="pickerDate"
                       :actions="false"
                       :allowed-dates="checkAllowedDates"
                       no-title
                       scrollable
                       locale="pt-BR"
                       @input="changeSelectedDate">
          <v-spacer v-if="clearable" />
          <v-btn v-if="clearable" text color="primary" @click="clearDate">
            {{ $t('clear') }}
          </v-btn>
        </v-date-picker>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'RegInlineCalendar',
  props: {
    date: {
      type: [Object, String]
    },
    prependIcon: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    textInputClass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    allowed: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayFormat: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    pickerDate: {
      type: String,
      default: undefined
    },
    large: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: false
    },
    returnAsMoment: {
      type: Boolean,
      default: false
    },
    defaultDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menu: false,
      localDate: '',
      formatted: ''
    }
  },
  computed: {
    allowedDates() {
      if (!this.allowed) {
        return null
      }

      return this.allowed.map(date => {
        return date.format('YYYY-MM-DD')
      })
    },
    hasError() {
      return this.$refs.input?.hasError
    }
  },
  watch: {
    date(value) {
      this.updateDate(value)
    },
    defaultDate: {
      handler: 'updateDefaultDate',
      immediate: true
    }
  },
  mounted() {
    this.updateDate(this.date)
  },
  methods: {
    updateDefaultDate(defaultDate) {
      if (this.date || !defaultDate) return
      let dynamicDate
      if (defaultDate === 'currentMonth') {
        dynamicDate = this.$moment().startOf('month').toDate()
      } else if (defaultDate === 'lastMonth') {
        dynamicDate = this.$moment().startOf('month').subtract(1, 'month').toDate()
      }
      if (dynamicDate) {
        this.changeSelectedDate(dynamicDate)
      }
    },
    parseInput(dateText) {
      const date = this.$moment(dateText, this.displayFormat)
      if (date.isValid()) {
        this.localDate = date.format('YYYY-MM-DD')
        this.changeSelectedDate(this.localDate)
      } else {
        this.localDate = ''
        this.changeSelectedDate(this.localDate)
      }
    },
    updateDate(date) {
      if (!_.isEmpty(date) && date.format) {
        this.localDate = date.format('YYYY-MM-DD')
      } else if (!_.isEmpty(date)) {
        this.localDate = String(date)
      } else {
        this.localDate = ''
      }

      this.updateFormated()
    },
    clearDate() {
      this.localDate = ''
      this.changeSelectedDate(this.localDate)
    },
    changeSelectedDate(date) {
      this.updateFormated()
      if (!date) {
        this.$emit('update:date', null)
        return
      }
      const returnDate = this.$moment(date, 'YYYY-MM-DD')
      if (this.returnAsMoment) {
        this.$emit('update:date', returnDate)
      } else {
        this.$emit('update:date', returnDate.format('YYYY-MM-DD'))
      }
    },
    updateFormated() {
      if (this.localDate === '') {
        this.formatted = ''
      } else {
        this.formatted = this.$moment(this.localDate, 'YYYY-MM-DD').format(this.displayFormat)
      }
    },
    clearInput() {
      this.localDate = ''
      this.updateFormated()
    },
    checkAllowedDates(date) {
      if (this.allowedDates) {
        return this.allowedDates.includes(date)
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.reg-large-inline-calendar {
  height: 44px;
  padding: 0px;
  .v-input-group__input {
    input {
      height: 40px;
      font-size: 18px;
    }
  }
}
</style>
